export default __webpack_public_path__ + "static/media/40.378970c8.jpg";